<template>
  <b-card no-body>
    <b-card-body>
      <admin-special-offer-detail
        ref="adminSpecialOfferDetail"
        type="new"
        :submitting="submitting"
        @submit="submit"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { BCard, BCardBody } from 'bootstrap-vue';
import { helper } from '@core/mixins/helper';
import useService from '@/auth/service/useService';
import AdminSpecialOfferDetail from '@/views/pages/special-offer/admin/SpecialOfferDetail.vue';

export default {
  components: {
    AdminSpecialOfferDetail,
    BCard,
    BCardBody
  },
  mixins: [helper],
  data() {
    return {
      submitting: false
    };
  },
  methods: {
    submit(data) {
      this.submitting = true;
      const { consignmentId } = this.$route.params;
      useService
        .createOffer(consignmentId, data)
        .then(response => {
          if (response.status) {
            this.$refs.adminSpecialOfferDetail.resetForm();
            this.showSuccessMessage(`${response.message}`);
            this.$router.push({ name: 'admin_special_offer' });
          }
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  },
  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
